import BeaconMetricColumnChart from './BeaconMetricColumnChart';

export default BeaconMetricColumnChart;
